"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _density = require("@site/pattern-library-utils/density");
var _dropdownPillMenu = _interopRequireDefault(require("../../../dropdown-pill-menu"));
var _pillSelection = _interopRequireDefault(require("../../../pill-selection"));
var _attachmentRow = require("./attachment-row");
var _productContent = _interopRequireDefault(require("../../../common/product-content"));
var _bundleContext = require("../../../context/bundle-context");
/**
 * Local Imports
 */

const Menu = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Menu",
  class: "pc-mqqjrah"
});
const GridContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "GridContainer",
  class: "pc-gicoojm"
});

/**
 * SelectableRow Component.
 *
 * @param {Object} props React props
 * @param {string} props._name Tracking name
 * @param {string} props.layouts The type of row ('dropdown' or 'radio')
 * @param {string} props.rowTitle The title of the row
 * @param {string} props.rowDisclaimer The disclaimer of the row
 * @param {Array} props.items The array of items for the row
 * @param {function} props.handleDropDownChange The function to handle dropdown change
 * @param {function} props.handlePillChange The function to handle pill change
 * @param {bool} props.displayDisable Applies disabled state to the row
 * @param {bool} props.split makes pillSelector into a split mode
 * @param {string} props.partialTheme Partial theme for the row
 * @returns {React.ReactElement} SelectableRow Component
 * @public
 */
function SelectableRow({
  _name,
  layouts,
  rowTitle,
  rowDisclaimer,
  items,
  handleDropDownChange,
  handlePillChange,
  displayDisable,
  partialTheme = 'precheck',
  instancePath,
  ...rest
}) {
  const {
    isComponentIncluded
  } = (0, _bundleContext.useBundleContext)();
  const isIncluded = isComponentIncluded(instancePath);
  if (!items) {
    return null;
  }
  const renderMenu = () => {
    if (layouts === 'termSelector') {
      return /*#__PURE__*/_react.default.createElement(Menu, null, items?.map((item, index) => /*#__PURE__*/_react.default.createElement(_dropdownPillMenu.default, (0, _extends2.default)({
        key: index
      }, rest, {
        options: item.options,
        onChange: selected => handleDropDownChange(selected, instancePath),
        _name: _name
      }))));
    } else if (layouts === 'pillSelector') {
      return /*#__PURE__*/_react.default.createElement(Menu, null, items?.map(item => {
        const {
          options,
          split,
          selectedOption
        } = item;
        const isSelected = options.findIndex(option => option.id === selectedOption);
        return /*#__PURE__*/_react.default.createElement(_pillSelection.default, (0, _extends2.default)({
          key: instancePath
        }, rest, {
          items: options,
          split: split,
          onChange: handlePillChange,
          selected: isSelected,
          partial: partialTheme
        }));
      }));
    }
  };
  const disabledPillSelector = displayDisable && layouts === 'pillSelector' || isIncluded && layouts === 'pillSelector' || isIncluded && layouts === 'termSelector';
  const className = `selectable-row-item ${rowTitle ? 'hasBorder' : ''}`;
  return /*#__PURE__*/_react.default.createElement(_attachmentRow.Container, {
    "data-cy": "selectable-row-item",
    className: className
  }, rowTitle && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": "row-title",
    className: "row-title",
    as: "title",
    text: rowTitle,
    size: 5
  }), /*#__PURE__*/_react.default.createElement(GridContainer, {
    className: disabledPillSelector && 'disabled'
  }, /*#__PURE__*/_react.default.createElement(_productContent.default, rest), renderMenu(), rowDisclaimer && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": "product-disclaimer",
    className: "row-disclaimer",
    as: "paragraph",
    text: rowDisclaimer,
    size: -1
  })));
}
var _default = exports.default = SelectableRow;
SelectableRow.propTypes = {
  layouts: _propTypes.default.string,
  rowTitle: _propTypes.default.string,
  rowDisclaimer: _propTypes.default.string,
  items: _propTypes.default.array,
  handleDropDownChange: _propTypes.default.func,
  handlePillChange: _propTypes.default.func,
  displayDisable: _propTypes.default.bool,
  split: _propTypes.default.bool,
  partialTheme: _propTypes.default.string,
  instancePath: _propTypes.default.string,
  _name: _propTypes.default.string
};